/**
 * WebSocket chat streaming event and status enums.
 * Matches backend transport envelope event types.
 */

/** 25 event types + 2 legacy (DELTA, COMPLETE) for backward compat */
export const MessageEvent = {
  // Run lifecycle
  RESPONSE_CREATED: 'chat.response.created',
  RESPONSE_IN_PROGRESS: 'chat.response.in_progress',
  RESPONSE_WRITING: 'chat.response.writing',
  RESPONSE_FINALIZING: 'chat.response.finalizing',
  RESPONSE_COMPLETED: 'chat.response.completed',
  RESPONSE_INCOMPLETE: 'chat.response.incomplete',
  RESPONSE_FAILED: 'chat.response.failed',
  RESPONSE_CANCEL_ACK: 'chat.response.cancel_ack',
  RESPONSE_CANCELLED: 'chat.response.cancelled',

  // Output
  OUTPUT_ITEM_ADDED: 'chat.response.output_item.added',
  OUTPUT_TEXT_DELTA: 'chat.response.output_text.delta',
  OUTPUT_UI_BLOCK_DELTA: 'chat.response.output_ui_block.delta',
  OUTPUT_ITEM_DONE: 'chat.response.output_item.done',
  OUTPUT_ITEM_COMMITTED: 'chat.response.output_item.committed',

  // Plan/Activity
  PLAN_PUBLISHED: 'chat.response.plan.published',
  PLAN_STEP_UPDATED: 'chat.response.plan_step.updated',
  ACTIVITY_STARTED: 'chat.response.activity.started',
  ACTIVITY_DONE: 'chat.response.activity.done',

  // Tool calls
  TOOL_CALL_STARTED: 'chat.response.tool_call.started',
  TOOL_CALL_COMPLETED: 'chat.response.tool_call.completed',
  TOOL_CALL_FAILED: 'chat.response.tool_call.failed',
  TOOL_CALL_CANCELLED: 'chat.response.tool_call.cancelled',

  // HITL
  INPUT_REQUIRED: 'chat.response.input.required',
  INPUT_UPDATED: 'chat.response.input.updated',

  // Sources
  SOURCES_FINAL: 'chat.response.sources.final',

  // Legacy (backward compat)
  DELTA: 'DELTA',
  COMPLETE: 'COMPLETE',
};

/** 13 message/response statuses */
export const MessageStatus = {
  CREATED: 'created',
  IN_PROGRESS: 'in_progress',
  WRITING: 'writing',
  FINALIZING: 'finalizing',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
  FAILED: 'failed',
  CANCEL_ACK: 'cancel_ack',
  CANCELLED: 'cancelled',
  PENDING: 'pending',
  RUNNING: 'running',
  DONE: 'done',
  ERROR: 'error',
};
